import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom'; // Replace with <a> if not using React Router
import RequestSettlement from 'components/widgets/modals/RequestSettlement';
import { ModalContext } from 'context/ModalContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { api_srv } from 'services';
import { fetchSettlementStats } from 'services/apiSrv';

// Styled components
const Container = styled.div`
  padding: 20px;
  font-family: 'Segoe UI', Arial, sans-serif;
  max-width: 800px;
  margin: 0 auto;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 30px;
  color: #333;
`;

const WalletCard = styled.div`
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const WalletHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Currency = styled.h3`
  margin: 0;
  color: #555;
`;

const Balance = styled.h2`
  margin: 0;
  font-size: 2.2em;
  color: #333;
`;

const RequestLink = styled(Link)`
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 1em;
  text-decoration: none;
  color: #333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background 0.2s;

  &:hover {
    background: #f0f0f0;
  }
`;

const SummaryCard = styled.div`
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const SummaryTitle = styled.h3`
  text-align: center;
  margin-bottom: 20px;
  color: #555;
`;

const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 1.1em;
`;

const SummaryLabel = styled.span`
  color: #666;
`;

const SummaryAmount = styled.span`
  font-weight: bold;
  color: #333;
`;

const BottomCards = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

const ClickableCard = styled(Link)`
  flex: 1;
  min-width: 250px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  color: inherit;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
    border-color: #999;
  }
`;

const IconWrapper = styled.div`
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardTitle = styled.h4`
  margin: 0;
  color: #444;
`;

// Main component
function Settlements(props) {
    const { setModalShow, modalShow, modalClose } = useContext(ModalContext);
    const { data:stats,error } = useQuery({
      queryKey: ['settlement-stats'],
      queryFn: async () => {
        const res = await fetchSettlementStats();
        return res.data || [];
      },
    });

    const onHide = () => {
      setModalShow(false)
    }


      const { data: wallets = [], isLoading } = useQuery({
        queryKey: ['wallet'],
        queryFn: async () => {
          const resp = await (await api_srv).fetch_wallet_info();
          return resp.data;
        },
      });

      let wallet = wallets?.[0]
    
  return (
    <Container>
      <Title>Configure how you want to be settled</Title>

      <WalletCard>
        <WalletHeader>
          <div>
            <Currency>{wallet?.accountCurrency}</Currency>
            <Balance>{wallet?.accountBalance}</Balance>
          </div>
          <button 
          style={{
            padding: '0.75em 1.5em',
            borderRadius: '0.375rem',
            border: 'none',
            background: '#16a34a',           // green-600
            fontSize: '1.125rem',
            fontWeight: 500,
            color: 'white',
            boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#15803d'} // green-700
          onMouseLeave={(e) => e.currentTarget.style.background = '#16a34a'}
          onClick={() => setModalShow(true)}
          >Request Settlement</button>
                <RequestSettlement show={modalShow} onHide={onHide} fetchBenefits={() => {}} />
        </WalletHeader>
      </WalletCard>

      <SummaryCard>
        <SummaryTitle>Summary</SummaryTitle>
        <SummaryRow>
          <SummaryLabel>Processing</SummaryLabel>
          <SummaryAmount>{stats?.PENDING}</SummaryAmount>
        </SummaryRow>
        <SummaryRow>
          <SummaryLabel>Failed</SummaryLabel>
          <SummaryAmount>{stats?.FAILED}</SummaryAmount>
        </SummaryRow>
        <SummaryRow>
          <SummaryLabel>Completed</SummaryLabel>
          <SummaryAmount>{stats?.COMPLETED}</SummaryAmount>
        </SummaryRow>
      </SummaryCard>

      <BottomCards>
        <ClickableCard to="/dashboard/settlements/configs">
          <IconWrapper>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" stroke-linejoin="round"></path> <path d="M12.9046 3.06005C12.6988 3 12.4659 3 12 3C11.5341 3 11.3012 3 11.0954 3.06005C10.7942 3.14794 10.5281 3.32808 10.3346 3.57511C10.2024 3.74388 10.1159 3.96016 9.94291 4.39272C9.69419 5.01452 9.00393 5.33471 8.36857 5.123L7.79779 4.93281C7.3929 4.79785 7.19045 4.73036 6.99196 4.7188C6.70039 4.70181 6.4102 4.77032 6.15701 4.9159C5.98465 5.01501 5.83376 5.16591 5.53197 5.4677C5.21122 5.78845 5.05084 5.94882 4.94896 6.13189C4.79927 6.40084 4.73595 6.70934 4.76759 7.01551C4.78912 7.2239 4.87335 7.43449 5.04182 7.85566C5.30565 8.51523 5.05184 9.26878 4.44272 9.63433L4.16521 9.80087C3.74031 10.0558 3.52786 10.1833 3.37354 10.3588C3.23698 10.5141 3.13401 10.696 3.07109 10.893C3 11.1156 3 11.3658 3 11.8663C3 12.4589 3 12.7551 3.09462 13.0088C3.17823 13.2329 3.31422 13.4337 3.49124 13.5946C3.69158 13.7766 3.96395 13.8856 4.50866 14.1035C5.06534 14.3261 5.35196 14.9441 5.16236 15.5129L4.94721 16.1584C4.79819 16.6054 4.72367 16.829 4.7169 17.0486C4.70875 17.3127 4.77049 17.5742 4.89587 17.8067C5.00015 18.0002 5.16678 18.1668 5.5 18.5C5.83323 18.8332 5.99985 18.9998 6.19325 19.1041C6.4258 19.2295 6.68733 19.2913 6.9514 19.2831C7.17102 19.2763 7.39456 19.2018 7.84164 19.0528L8.36862 18.8771C9.00393 18.6654 9.6942 18.9855 9.94291 19.6073C10.1159 20.0398 10.2024 20.2561 10.3346 20.4249C10.5281 20.6719 10.7942 20.8521 11.0954 20.94C11.3012 21 11.5341 21 12 21C12.4659 21 12.6988 21 12.9046 20.94C13.2058 20.8521 13.4719 20.6719 13.6654 20.4249C13.7976 20.2561 13.8841 20.0398 14.0571 19.6073C14.3058 18.9855 14.9961 18.6654 15.6313 18.8773L16.1579 19.0529C16.605 19.2019 16.8286 19.2764 17.0482 19.2832C17.3123 19.2913 17.5738 19.2296 17.8063 19.1042C17.9997 18.9999 18.1664 18.8333 18.4996 18.5001C18.8328 18.1669 18.9994 18.0002 19.1037 17.8068C19.2291 17.5743 19.2908 17.3127 19.2827 17.0487C19.2759 16.8291 19.2014 16.6055 19.0524 16.1584L18.8374 15.5134C18.6477 14.9444 18.9344 14.3262 19.4913 14.1035C20.036 13.8856 20.3084 13.7766 20.5088 13.5946C20.6858 13.4337 20.8218 13.2329 20.9054 13.0088C21 12.7551 21 12.4589 21 11.8663C21 11.3658 21 11.1156 20.9289 10.893C20.866 10.696 20.763 10.5141 20.6265 10.3588C20.4721 10.1833 20.2597 10.0558 19.8348 9.80087L19.5569 9.63416C18.9478 9.26867 18.6939 8.51514 18.9578 7.85558C19.1262 7.43443 19.2105 7.22383 19.232 7.01543C19.2636 6.70926 19.2003 6.40077 19.0506 6.13181C18.9487 5.94875 18.7884 5.78837 18.4676 5.46762C18.1658 5.16584 18.0149 5.01494 17.8426 4.91583C17.5894 4.77024 17.2992 4.70174 17.0076 4.71872C16.8091 4.73029 16.6067 4.79777 16.2018 4.93273L15.6314 5.12287C14.9961 5.33464 14.3058 5.0145 14.0571 4.39272C13.8841 3.96016 13.7976 3.74388 13.6654 3.57511C13.4719 3.32808 13.2058 3.14794 12.9046 3.06005Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" stroke-linejoin="round"></path> </g></svg>
          </IconWrapper>
          <CardTitle>Settlement Config</CardTitle>
        </ClickableCard>

        <ClickableCard to="/dashboard/settlements/requests">
          <IconWrapper>
<svg viewBox="0 0 24 24" fill="none"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M11.25 7.84748C10.3141 8.10339 9.75 8.82154 9.75 9.5C9.75 10.1785 10.3141 10.8966 11.25 11.1525V7.84748Z" fill="#1C274C"></path> <path d="M12.75 12.8475V16.1525C13.6859 15.8966 14.25 15.1785 14.25 14.5C14.25 13.8215 13.6859 13.1034 12.75 12.8475Z" fill="#1C274C"></path> <path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V6.31673C14.3804 6.60867 15.75 7.83361 15.75 9.5C15.75 9.91421 15.4142 10.25 15 10.25C14.5858 10.25 14.25 9.91421 14.25 9.5C14.25 8.82154 13.6859 8.10339 12.75 7.84748V11.3167C14.3804 11.6087 15.75 12.8336 15.75 14.5C15.75 16.1664 14.3804 17.3913 12.75 17.6833V18C12.75 18.4142 12.4142 18.75 12 18.75C11.5858 18.75 11.25 18.4142 11.25 18V17.6833C9.61957 17.3913 8.25 16.1664 8.25 14.5C8.25 14.0858 8.58579 13.75 9 13.75C9.41421 13.75 9.75 14.0858 9.75 14.5C9.75 15.1785 10.3141 15.8966 11.25 16.1525V12.6833C9.61957 12.3913 8.25 11.1664 8.25 9.5C8.25 7.83361 9.61957 6.60867 11.25 6.31673V6C11.25 5.58579 11.5858 5.25 12 5.25Z" fill="#1C274C"></path> </g></svg>
          </IconWrapper>
          <CardTitle>Settlement Request</CardTitle>
        </ClickableCard>
      </BottomCards>
    </Container>
  );
}

export default Settlements;